/* var rootUrl = aws_data['rootUrl'],
    wpurl = aws_data['wpurl'],
    themeUrl = aws_data['themeUrl']; */

import daysTrigger from './modules/days-trigger';
import emailFieldToggle from './modules/email-field-toggle';
import jumpFocus from './modules/jump-focus';
import livePhoneFormat from './modules/live-phone-format';
import loginFormControl from './modules/login-form-control';
import otherToggle from './modules/other-toggle';
import postalCodeRegexChanger from './modules/postal-code-regex-changer';
import radioBtnInit from './modules/radio-btn-init';
import selectize from './modules/selectize';
import signUpFormControl from './modules/signup-form-control';
import resetPwdFormControl from './modules/reset-pwd-form-control';
import stateToggle from './modules/state-toggle';
import validation from './modules/validation';
import mobileValidation from './modules/mobileValidation';
import autoLogout from './modules/auto-logout';
import disablePointerEvents from './modules/disable-pointer-events';
import dashboardController from "./modules/dashboard";

function loadExtraScriptFile() {
  // How to load a JS file ? awspro_load_js(wpurl + 'wp-content/plugins/JS FILE PATH');
  // How to load a CSS file ? awspro_load_css(wpurl + 'wp-content/plugins/CSS FILE PATH');
  // Write your custom JS code here which you want to load after every ajax call complete

  function playVideo1() {
    const video1 = document.getElementById('video-1');
    if (video1) {
      video1.play();
    }
  }

  TweenMax.set($('.why-embassy .bank-card'), { rotationZ: -90 });
  TweenMax.set('.fade-rise', { opacity: 0, y: 50 });
  TweenMax.set('.fade-slide-from-left', { opacity: 0, x: -100 });
  TweenMax.set('.fade-slide-from-right', { opacity: 0, x: 100 });
  TweenMax.set('.faqs-accordian .faq-entry', { opacity: 0, y: 50 });
  TweenMax.set('.hero-content', { opacity: 0, x: -100 });
  TweenMax.set('.phone-hand--wrap', { opacity: 0, x: 100 });
  TweenMax.set('.hero-wrap .slice', { x: -75 });
  TweenMax.to('.hero-content', 0.9,
    {
      delay: 0.3, opacity: 1, x: 0, ease: Power3.easeOut, force3D: true,
    });
  TweenMax.to('.phone-hand--wrap', 0.9, {
    delay: 0.3,
    opacity: 1,
    x: 0,
    ease: Power3.easeOut,
    force3D: true,
    onComplete: playVideo1,
  });
  TweenMax.to('.hero-wrap .slice', 1.1,
    { x: 0, ease: Power3.easeOut, force3D: true });

  const shapes = '.feature-icon path';
  const tl = new TimelineMax({ delay: 0, paused: true });
  tl.fromTo(shapes, 8, { drawSVG: '0%' }, { drawSVG: '100%' });
  $('.inview-item').on('inview', function (event, isInView) {
    if (isInView) {
      $(this).addClass('is-inview');
    }
  });
  $('.feature-item').one('inview', (event, isInView) => {
    if (isInView) {
      tl.play();
    }
  });
  $('.fade-rise').one('inview', function (event, isInView) {
    if (isInView) {
      TweenMax.to($(this), 0.3, { opacity: 1, y: 0 });
    }
  });
  $('.faqs-accordian').one('inview', (event, isInView) => {
    if (isInView) {
      TweenMax.staggerTo($('.faqs-accordian .faq-entry'), 0.3,
        { opacity: 1, y: 0 }, 0.1);
    }
  });

  function playVideo2() {
    const video2 = document.getElementById('video-2');
    if (video2) {
      video2.play();
    }
  }

  $('.why-embassy').one('inview', function (event, isInView) {
    if (isInView) {
      TweenMax.to($('.fade-slide-from-left, .fade-slide-from-right', this), 0.8,
        {
          delay: 0.2, opacity: 1, x: 0, onComplete: playVideo2,
        });
      TweenMax.to($('.bank-card', this), 0.5, { delay: 0.5, rotationZ: -45 });
    }
  });

  $('.using-your-card, .merchant-intro').one('inview', function (event, isInView) {
    if (isInView) {
      TweenMax.to($('.fade-slide-from-left, .fade-slide-from-right', this), 0.8,
        { delay: 0.2, opacity: 1, x: 0 });
    }
  });

  $('.device-entry--details').matchHeight();
  $('.card-details').matchHeight();
  $('.card-pricing').matchHeight();

  const $cardsCarousel = $('.cards-carousel').flickity({
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    selectedAttraction: 0.012,
  });
  const $carousel = $('.carousel').flickity({
    cellAlign: 'left',
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: true,
  });
  // Fix autoplay after drag
  $carousel.on('dragEnd.flickity', () => {
    $carousel.flickity('playPlayer');
  });
  // previous wrapped
  $('.carousel-prev').on('click', () => {
    $cardsCarousel.flickity('previous', true);
  });
  // next wrapped
  $('.carousel-next').on('click', () => {
    $cardsCarousel.flickity('next', true);
  });

  $(() => {
    const $el = $('.parallax-background');
    $(window).on('scroll', () => {
      const scroll = $(document).scrollTop();
      $el.css({
        'background-position': `50% ${+0.4 * scroll}px`,
      });
    });
  });

  $(document).ready(() => {
    signUpFormControl();
    resetPwdFormControl();
    validation();
    jumpFocus();
    autoLogout();
    selectize();
    radioBtnInit();
    stateToggle();
    emailFieldToggle();
    postalCodeRegexChanger();
    loginFormControl();
    otherToggle();
    //livePhoneFormat();
    daysTrigger();
    disablePointerEvents();
    mobileValidation();
    dashboardController();
  });
} // End main function

window.load_extra_script_file = loadExtraScriptFile;

function resizeElements() {
  const windowHeight = $(window).height();
  $('.mobile-menu').css('height', windowHeight);
}

$(window).on('resize', resizeElements);

$(window).on('load', () => {
  $('.site').animate({ opacity: 1 }, 300);
  window.load_extra_script_file();
  resizeElements();
});

$(document).ready(() => {
  resizeElements();

  // show/hide content
  $(document.body).on('click', '.js-show-hide', function (event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $(this).closest('.show-hide--wrap').find('.show-hide--content').slideToggle(
      200,
    );
  });
  $(document.body).on('click', '.pricing-toggle', function (event) {
    event.preventDefault();
    $(this).parent().find('.card-pricing').slideToggle(200);
  });

  $(document.body).on('click', '.menu-toggle', () => {
    $('body').toggleClass('menu-open');
  });
});

$(window).scroll(() => {
  if (window.scrollY > 40) {
    $('html').addClass('page-scrolled');
  } else {
    $('html').removeClass('page-scrolled');
  }
});
